module.exports = __webpack_public_path__ + "02_medium_black.69476dc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_medium_black.png
// module id = 4c9u
// module chunks = 0